import axios from "axios";
import { useState } from "react";
import "../../../styles/DatasetPage.css";
import "../../../styles/org-buttons.css";
import { getFiftyOneRequestContext } from "../../../utils/fiftyone";
import { buttonText } from "../../../utils/buttonText";

function PickerPage(props) {
  const { item, loadDatasetList } = props;

  const [targetDataset, setTargetDataset] = useState(null);
  const [loading, setLoading] = useState(false);

  const pick = async () => {
    if (!item.samples.length || item.samples.length === 0) {
      window.alert(`There is no sample in dataset '${item.name}'`);
      return;
    }
    if (!targetDataset) {
      window.alert("Please input a target dataset name.");
      return;
    }
    setLoading(true);
    try {
      await axios.put("/datasets/move/samples/selected", {
        dataset_name: item.name,
        target_dataset_name: targetDataset,
        ...getFiftyOneRequestContext(),
      });
      loadDatasetList();
      const msg = `Move samples from '${item.name}' to '${targetDataset}' success.`;
      window.alert(msg);
    } catch (error) {
      const errorMsg =
        error.response?.data?.error || error.response?.data || error.message;
      window.alert(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="picker-page">
      <p className="card-text">{item.name}</p>
      <p className="card-text">samples num: {item.samples.length}</p>
      <div className="picker-input-content">
        <input
          type="text"
          id="target-dataset-name"
          placeholder="target dataset name"
          value={targetDataset}
          onChange={(e) => {
            setTargetDataset(e.target.value);
          }}
        />
        <button
          type="button"
          className="org-btn org-btn-primary"
          onClick={pick}
          disabled={loading}
        >
          {buttonText(loading ? "Loading..." : "Pick")}
        </button>
      </div>
    </div>
  );
}

export default PickerPage;
